<template>
  <el-dialog @close="onClose" :title="`${type == 1 ? '完成外观确认' : '完成装卸确认'}`" :visible.sync="visible" width="600px">
    <div style="margin-bottom: 10px;">确认{{type == 1 ? '完成外观确认' : '完成卸货确认'}}吗？</div>
    <el-form ref="form" label-width="80px" :model="form">
      <el-form-item label="质检照片" prop="files" v-if="type == 1" :rules="[{ required: true, message: '请上传质检图片', trigger: 'change', type: 'array' }]">
        <c-file-upload
          class="w-96"
          :isShowTip="false"
          :fileType="['png', 'jpg', 'jpeg']"
          v-model="form['files']"
          :limit="9"
        ></c-file-upload>
      </el-form-item>
      <template v-if="type == 2">
        <el-form-item
        label="存储地点"
        prop="storage_point_id"
        :rules="[{ required: true, message: '请选择存储地点', trigger: 'change' }]"
      >
        <el-select class="w-96" filterable @change="onStorageChange" v-model="form.storage_point_id" placeholder="请选择">
          <el-option
            v-for="item in storagePoints"
            :key="item.storage_point_id"
            :label="`${item.storage_point_id}（${item.storage_point_name}）`"
            :value="item.storage_point_id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="垛位"
        prop="stack_position_id"
        v-if="stackPosition.length > 0"
        :rules="[{ required: true, message: '请选择垛位', trigger: 'change' }]"
      >
        <el-select class="w-96" filterable v-model="form.stack_position_id" placeholder="请选择">
          <el-option
            v-for="item in stackPosition"
            :key="item.stack_position_id"
            :label="`${item.stack_position_name}（${item.stack_position_id}）`"
            :value="item.stack_position_id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="卸货班组"
        prop="unload_team_id"
        :rules="[{ required: true, message: '请选择卸货班组', trigger: 'change' }]"
      >
        <el-select class="w-96" filterable v-model="form.unload_team_id" placeholder="请选择">
          <el-option
            v-for="item in unloadTeam"
            :key="item.unload_team_id"
            :label="item.unload_team_name"
            :value="item.unload_team_id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="isGuofeiEndUnload"
        label="放柜区域"
        prop="put_area"
        :rules="[{ required: true, message: '请选择放柜区域', trigger: 'change' }]"
      >
        <el-select
          class="w-96"
          filterable
          v-model="form.put_area"
          placeholder="请选择放柜区域"
        >
          <el-option
            v-for="item in areaOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      </template>
      <el-form-item label="退货" prop="is_return">
        <el-switch @change="form.is_partial_return = 0" v-model="form.is_return" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item>
      <el-form-item label="部分退货" prop="is_partial_return">
        <el-switch @change="form.is_return = 0" v-model="form.is_partial_return" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item>
      <el-form-item v-if="type == 2" label="异常备注" prop="unload_abnormal_remark">
        <el-select class="w-96" v-model="form.unload_abnormal_remark" placeholder="请选择异常备注">
          <el-option
            v-for="item in unloadAbnormalRemarkOptions"
            :key="item.value || 'default'"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="unload_remark" label-width="0px">
        <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="form.unload_remark"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="onConfirm">
        {{ type == 1 ? '确认完成外观检查' : '确认装卸' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      type: 1,
      visible: false,
      form: {},
      matnr: "",
      storagePoints: [],
      stackPosition: [],
      unloadTeam: [],
      areaOption: [],
      // 关键步骤：空字符串统一代表“无（默认）”，和后端落库语义保持一致。
      unloadAbnormalRemarkOptions: [
        { label: "无（默认）", value: "" },
        { label: "雨布到底", value: "雨布到底" },
        { label: "取样时间过长", value: "取样时间过长" },
        { label: "二次取样", value: "二次取样" },
        { label: "翻板改平地卸货", value: "翻板改平地卸货" },
        { label: "送货司机进厂睡觉", value: "送货司机进厂睡觉" },
        { label: "侧门不能打开", value: "侧门不能打开" },
        { label: "其他", value: "其他" }
      ]
    };
  },
  computed: {
    isGuofeiEndUnload() {
      return this.type == 2 && this.form.order_type === "IB";
    },
    unload_team_name() {
      return this.form.unload_team_id
        ? this.unloadTeam.find(
            item => item.unload_team_id === this.form.unload_team_id
          ).unload_team_name
        : "";
    },
    storage_point_name() {
      return this.form.storage_point_id
        ? this.storagePoints.find(
            item => item.storage_point_id === this.form.storage_point_id
          ).storage_point_name
        : "";
    },
    stack_position_name() {
      return this.form.stack_position_id
        ? this.stackPosition.find(
            item => item.stack_position_id === this.form.stack_position_id
          ).stack_position_name
        : "";
    },
    put_area_name() {
      const selectedArea = this.areaOption.find(item => item.value === this.form.put_area);
      return selectedArea ? selectedArea.label : (this.form.put_area_name || "");
    }
  },
  methods: {
    onClose() {
      this.form = {};
      this.stackPosition = [];
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    onOpen(data, type) {
      this.type = type;
      this.matnr = data.chip_code;
      this.form.booking_id = data.booking_id;
      this.$set(this.form, 'order_type', data.order_type || '');
      this.$set(this.form, 'put_area', data.put_area || '');
      this.$set(this.form, 'put_area_name', data.put_area_name || '');
      if (type == 2) {
        const { 
          // storage_point_id,
          // stack_position_id,
          // unload_team_id,
          is_return,
          is_partial_return
        } = data.queue;
        // this.$set(this.form, 'storage_point_id', storage_point_id);
        // if (stack_position_id) {
        //   this.$set(this.form, 'stack_position_id', stack_position_id);
        //   this.getStackPosition();
        // }
        // this.$set(this.form, 'unload_team_id', unload_team_id);
        this.$set(this.form, 'is_partial_return', is_partial_return);
        this.$set(this.form, 'is_return', is_return);
        this.$set(this.form, 'unload_abnormal_remark', data.queue.unload_abnormal_remark || "");
        // this.$set(this.form, 'unload_remark', unload_remark);
        if (this.form.order_type === "IB" && !this.areaOption.length) {
          this.getPutArea();
        }
      }
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    onStorageChange(value) {
      this.stackPosition = [];
      if (value) {
        const storage = this.storagePoints.find((e) => e.storage_point_id === value);
        if (storage.need_stack_position === 1) {
          this.getStackPosition();
        }
      }
    },
    async getStoragePoints() {
      try {
        const dataObj = await this.$common.http({
          url: "/api/queue/dispatcher/query_storage_point"
        });
        this.storagePoints = dataObj.data.data;
      } catch (error) {}
    },
    async getStackPosition() {
      try {
        const dataObj = await this.$common.http({
          url: "/api/queue/dispatcher/query_stack_position",
          data: {
            matnr: this.matnr,
            storage_point_id: this.form.storage_point_id
          }
        });
        this.stackPosition = dataObj.data.data;
      } catch (error) {}
    },
    async getUnloadTeam() {
      try {
        const dataObj = await this.$common.http({
          url: "/api/queue/dispatcher/query_unload_team"
        });
        this.unloadTeam = dataObj.data.data;
      } catch (error) {}
    },
    async getPutArea() {
      try {
        const dataObj = await this.$common.http({
          url: "/api/sap/query_put_area"
        });
        this.areaOption = (dataObj.data.data || []).map(item => {
          return {
            ...item,
            label: `${item.put_area_name}（${item.put_area_code}）`,
            value: item.put_area_id
          };
        });
      } catch (error) {}
    },
    onConfirm() {
      this.$refs.form.validate(async v => {
        if (v) {
          try {
            let url = ""
            let params = Object.assign(this.form, {
              unload_team_name: this.unload_team_name,
              storage_point_name: this.storage_point_name,
              stack_position_name: this.stack_position_name,
              put_area_name: this.put_area_name,
            });
            if (this.type === 1) {
              params.check = 1;
              url = "/api/queue/dispatcher/begin_unload"
            } else {
              url = "/api/queue/dispatcher/end_unload"
            }
            await this.$common.http({ url, data: params });
            this.$emit("ok");
            this.visible = false;
          } catch (error) {}
        }
      });
    }
  },
  created() {
    this.getStoragePoints();
    this.getUnloadTeam();
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 10px 15px !important;
}
</style>
